<app-basic-select [options]="currencies" [(ngModel)]="localValue" [iconClass]="'toggles fw-semibold'" [title]="title" (ngModelChange)="onValueChange($event)"></app-basic-select>
